// What the global error toast says for a failed API call.
//
// A coded error from the backend carries its text in `messages`; the toast
// shows that. A bare failure (most 5xx) has an empty list, and a request that
// never reached the server has no response at all; both get a generic line
// that still names the status and the URL, so the toast is never blank.
export type ApiError = {
  response?: { status?: number; statusText?: string; data?: { messages?: unknown } };
  request?: { responseURL?: string };
  config?: { url?: string };
};

export const NETWORK_ERROR_TEXT = 'A network error occurred.';

export const apiErrorMessage = (error: ApiError): string | JSX.Element => {
  if (!error.response) {
    return (
      <span>
        <strong>{NETWORK_ERROR_TEXT}</strong>
        <br />
        This could be a CORS issue, API host is unreachable or a dropped internet connection.
      </span>
    );
  }
  const raw = error.response.data?.messages;
  const messages = (Array.isArray(raw) ? raw : []).filter((m): m is string => typeof m === 'string' && m.trim() !== '');
  if (messages.length) {
    return messages.join('\n');
  }
  const url = error.request?.responseURL || error.config?.url || '';
  return (
    <span>
      API Error. {error.response.status ?? ''}: {error.response.statusText || 'Request failed'}
      <br />
      {url}
    </span>
  );
};
